import { sql } from 'drizzle-orm'

export const migrate0001 = sql`CREATE TABLE \`accountPolkadotExtrinsicRelation\` (
	\`accountId\` integer NOT NULL,
	\`blockNumber\` integer NOT NULL,
	\`extrinsicIndex\` integer,
	\`analyzed\` integer NOT NULL,
	FOREIGN KEY (\`accountId\`) REFERENCES \`account\`(\`id\`) ON UPDATE no action ON DELETE no action
);
--> statement-breakpoint
CREATE TABLE \`polkadotExtrinsic\` (
	\`chainId\` integer NOT NULL,
	\`blockNumber\` integer NOT NULL,
	\`extrinsicIndex\` integer,
	\`timestamp\` integer NOT NULL
);
--> statement-breakpoint
ALTER TABLE \`account\` ADD \`polkadotChainId\` integer;--> statement-breakpoint
ALTER TABLE \`account\` ADD \`polkadotAddress\` text;--> statement-breakpoint
ALTER TABLE \`account\` ADD \`polkadotToBlock\` integer;--> statement-breakpoint
ALTER TABLE \`actionSource\` ADD \`polkadotChainId\` integer;--> statement-breakpoint
ALTER TABLE \`actionSource\` ADD \`polkadotBlockNumber\` integer;--> statement-breakpoint
ALTER TABLE \`actionSource\` ADD \`polkadotExtrinsicIndex\` integer;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_accountPolkadotExtrinsicRelation\` ON \`accountPolkadotExtrinsicRelation\` (\`accountId\`,\`blockNumber\`,\`extrinsicIndex\`);--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_polkadotExtrinsic\` ON \`polkadotExtrinsic\` (\`chainId\`,\`blockNumber\`,\`extrinsicIndex\`);--> statement-breakpoint
CREATE UNIQUE INDEX \`account_polkadotChainId_polkadotAddress_unique\` ON \`account\` (\`polkadotChainId\`,\`polkadotAddress\`);`
